import React from 'react';
import useModuleData from '@wix/da-gruser-shared/pkg/hooks/useModuleData';
import { PapiModuleExhibitionist } from '@wix/da-papi-types';
import { ExhibitionistSlideFitMode } from '../ExhibitionistConfigPopover/types';
import DeviationSlideshow from './DeviationSlideshow';

interface Props {
  moduleId: number;
}

const ExhibitionistSlideshow: React.FC<Props> = ({ moduleId }) => {
  const { moduleData } = useModuleData<PapiModuleExhibitionist>(moduleId);
  const { deviations, slideImageFit } = moduleData;
  return (
    <DeviationSlideshow
      items={deviations}
      useCoverMode={slideImageFit === ExhibitionistSlideFitMode.COVER}
    />
  );
};
ExhibitionistSlideshow.displayName = 'ExhibitionistSlideshow';

export default ExhibitionistSlideshow;
